import {RiskTypes} from '../enum/risk-types';

export class Risks {
    flood: string = null;
    seaWater: string = null;
    earthquake: string = null;
    tsunamis: string = null;
    cyclones: string = null;
    hail: string = null;
    winterStorm: string = null;
    nationalPoliticsDanger: string = null;
    localPoliticsDanger: string = null;

    constructor(object: any) {
        // Map the keys from the API response to the properties of the class
        this.flood = object[RiskTypes.FLOOD] !== undefined ? object[RiskTypes.FLOOD].toString() : null;
        this.seaWater = object[RiskTypes.SEA_WATER] !== undefined ? object[RiskTypes.SEA_WATER].toString() : null;
        this.earthquake = object[RiskTypes.EARTHQUAKE] !== undefined ? object[RiskTypes.EARTHQUAKE].toString() : null;
        this.tsunamis = object[RiskTypes.TSUNAMIS] !== undefined ? object[RiskTypes.TSUNAMIS].toString() : null;
        this.cyclones = object[RiskTypes.CYCLONES] !== undefined ? object[RiskTypes.CYCLONES].toString() : null;
        this.hail = object[RiskTypes.HAIL] !== undefined ? object[RiskTypes.HAIL].toString() : null;
        this.winterStorm = object[RiskTypes.WINTER_STORM] !== undefined ? object[RiskTypes.WINTER_STORM].toString() : null;
        this.nationalPoliticsDanger = object[RiskTypes.NATIONAL_POLITICS_DANGER] !== undefined ? object[RiskTypes.NATIONAL_POLITICS_DANGER].toString() : null;
        this.localPoliticsDanger = object[RiskTypes.LOCAL_POLITICS_DANGER] !== undefined ? object[RiskTypes.LOCAL_POLITICS_DANGER].toString() : null;
    }
}
